// DTOs synchrones avec workers/api/src/domain/types.ts
// (sera dans @orientation/shared-types plus tard)

export type Profile = {
  id: string;
  email: string;
  full_name: string | null;
  role: "admin" | "organisateur";
  created_at: string;
  last_login_at: string | null;
};

export type Lieu = {
  id: string;
  owner_id: string | null;
  nom: string;
  description: string | null;
  image_key: string | null;
  image_width: number | null;
  image_height: number | null;
  created_at: string;
};

export type Balise = {
  id: string;
  lieu_id: string;
  nom: string | null;
  position_x: number;
  position_y: number;
  ordre_suggere: number | null;
  lat: number | null;
  lng: number | null;
  emoji_3d: string | null;
  couleur_3d: string | null;
  model_3d_key: string | null;
  created_at: string;
};

export const NIVEAUX = ["CP", "CE1", "CE2", "CM1", "CM2", "6e", "5e"] as const;
export type Niveau = (typeof NIVEAUX)[number];

export type Question = {
  id: string;
  owner_id: string | null;
  texte: string;
  reponses: string[];
  indice: string | null;
  matiere: string | null;
  niveau: string | null;
  difficulte: number;
  emoji: string | null;
  created_at: string;
};

export type QuestionInput = {
  texte: string;
  reponses: string[];
  indice?: string | null;
  matiere?: string | null;
  niveau?: string | null;
  difficulte?: number;
  emoji?: string | null;
};

export type QuestionFilters = {
  niveau?: string;
  matiere?: string;
  search?: string;
  limit?: number;
  offset?: number;
};

export type ParcoursConfig = {
  blocus_actif: boolean;
  blocus_nombre: number;
  max_erreurs: number;
};

export const DEFAULT_PARCOURS_CONFIG: ParcoursConfig = {
  blocus_actif: true,
  blocus_nombre: 3,
  max_erreurs: 3,
};

export type Parcours = {
  id: string;
  lieu_id: string;
  owner_id: string | null;
  nom: string;
  niveau: string | null;
  config: ParcoursConfig;
  created_at: string;
};

export type ParcoursEtape = {
  parcours_id: string;
  balise_id: string;
  question_ids: string[];
};

export type ParcoursWithEtapes = {
  parcours: Parcours;
  etapes: ParcoursEtape[];
};

export type ParcoursInput = {
  lieu_id: string;
  nom: string;
  niveau?: string | null;
  config?: Partial<ParcoursConfig>;
};

export type ParcoursUpdateInput = Partial<Omit<ParcoursInput, "lieu_id">>;

export const SESSION_STATUTS = ["preparee", "en_cours", "terminee"] as const;
export type SessionStatut = (typeof SESSION_STATUTS)[number];

export type Session = {
  id: string;
  lieu_id: string;
  owner_id: string | null;
  nom: string;
  date_debut: string;
  date_fin: string | null;
  statut: SessionStatut;
  mot_secret_base: string;
  created_at: string;
};

export type Groupe = {
  id: string;
  session_id: string;
  parcours_id: string;
  nom: string;
  niveau: string | null;
  code_acces: string;
  created_at: string;
};

export type SessionWithGroupes = {
  session: Session;
  groupes: Groupe[];
};

export type SessionInput = {
  lieu_id: string;
  nom: string;
  date_debut: string;
  date_fin?: string | null;
  mot_secret_base: string;
};

export type SessionUpdateInput = Partial<Omit<SessionInput, "lieu_id">>;

export type GroupeInput = {
  parcours_id: string;
  nom: string;
  niveau?: string | null;
  code_acces?: string;
};

export type GroupeUpdateInput = Partial<Omit<GroupeInput, "code_acces">>;

// ---------- Dashboard ----------
export type BlocusDashboard = {
  balise_id: string;
  balise_nom: string | null;
  raison: "alea" | "erreurs" | null;
  since: string;
};

export type GroupeDashboard = {
  groupe: Groupe & { balises_blocus_alea?: string[] };
  parcours: { id: string; nom: string; niveau: string | null } | null;
  total_balises: number;
  validees: number;
  en_cours: number;
  blocus: BlocusDashboard[];
  derniere_activite: string | null;
  points_total: number;
  termine: boolean;
};

export type SessionDashboard = {
  session: Session;
  groupes: GroupeDashboard[];
  total_groupes: number;
  nb_actifs: number;
  nb_blocus_total: number;
  fetched_at: string;
};

export type LoginResponse = {
  ok: true;
  user: Profile;
  access_token: string;
  refresh_token: string;
  expires_in: number;
};

export type ApiError = {
  ok: false;
  error: string;
  message: string;
};
